module.exports = __webpack_public_path__ + "img/underlyingDisease.00215632.png";